<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>단타의 신 · 서버 설정</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-tabs v-model="settingTab" color="primary" class="mt-0">
        <v-tab><v-icon left small>mdi-cog</v-icon>일반 설정</v-tab>
        <v-tab><v-icon left small>mdi-server-network</v-icon>노티 서버</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="settingTab">
        <!-- 탭1: 일반 설정 -->
        <v-tab-item>
          <v-card-text class="pa-6 text-center">
            <v-icon size="64" color="grey lighten-1">mdi-cog</v-icon>
            <p class="text-body-1 grey--text mt-4">일반 설정 준비중입니다.</p>
          </v-card-text>
        </v-tab-item>

        <!-- 탭2: 노티 서버 관리 -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="info" class="mb-4 body-2">
              노티 서버는 Redis Pub/Sub을 구독하여 유저에게 실시간 알림을 전달합니다.
              스케일업 시 API 서버에서 유저를 로드밸런싱하여 각 노티 서버에 분배합니다.
            </v-alert>

            <div class="d-flex align-center mb-3">
              <span class="text-subtitle-1 font-weight-bold">노티 서버 리스트</span>
              <v-spacer></v-spacer>
              <v-btn small color="primary" outlined @click="openNotiDialog">
                <v-icon left small>mdi-plus</v-icon>서버 추가
              </v-btn>
            </div>

            <v-data-table
              :headers="notiHeaders"
              :items="notiServerList"
              :items-per-page="10"
              hide-default-footer
              class="elevation-0"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn icon small @click="openNotiEditDialog(item)" title="수정">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small color="red" @click="deleteNotiServer(item)" title="삭제">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>

            <v-container v-if="notiServerList.length === 0" class="text-center py-6">
              <v-icon size="48" color="grey lighten-1">mdi-server-off</v-icon>
              <p class="text-body-2 grey--text mt-2">등록된 노티 서버가 없습니다.</p>
            </v-container>

          </v-card-text>
        </v-tab-item>

        <!-- (일반설정은 위로 이동) -->
      </v-tabs-items>
    </v-card>

    <!-- 노티 서버 등록/수정 다이얼로그 -->
    <v-dialog v-model="notiDialog" max-width="520" scrollable>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="primary">mdi-server-network</v-icon>
          {{ notiIsEdit ? '노티 서버 수정' : '노티 서버 추가' }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-text-field
            v-model="notiForm.server_id"
            label="서버 ID *"
            outlined dense
            class="mb-3"
            :readonly="notiIsEdit"
            placeholder="broadcast-1"
            hint="ecosystem.config.js 의 BROADCAST_SERVER_ID 와 정확히 일치해야 가중치 반영 (예: broadcast-1, broadcast-2)"
            persistent-hint
          ></v-text-field>
          <v-text-field v-model="notiForm.server_name" label="서버 이름 *" outlined dense hide-details class="mb-3" placeholder="라이브 1번 채팅"></v-text-field>
          <v-row dense>
            <v-col cols="7">
              <v-text-field v-model="notiForm.host" label="호스트" outlined dense hide-details class="mb-3" placeholder="(참고용)"></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field v-model="notiForm.port" label="포트" outlined dense hide-details class="mb-3" type="number" placeholder="(참고용)"></v-text-field>
            </v-col>
          </v-row>
          <v-text-field
            v-model="notiForm.weight"
            label="가중치 *"
            outlined dense
            class="mb-3"
            type="number"
            min="1"
            hint="실제 트래픽 분산에 반영. 1=균등, 2=다른 서버 대비 2배 배정. 0/음수 불가."
            persistent-hint
          ></v-text-field>
          <v-textarea v-model="notiForm.memo" label="메모" outlined dense hide-details class="mb-3" rows="2"></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="notiDialog = false">취소</v-btn>
          <v-btn color="primary" depressed @click="saveNotiServer">
            <v-icon left small>mdi-check</v-icon>{{ notiIsEdit ? '수정' : '추가' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="py-12"></div>
    <div class="py-12"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Danta_GameSetting',
  data: () => ({
    settingTab: 0,
    notiDialog: false,
    notiIsEdit: false,
    notiServerList: [],
    notiHeaders: [
      { text: '서버 이름', value: 'server_name', width: '160px' },
      { text: '호스트', value: 'host', width: '160px' },
      { text: '포트', value: 'port', width: '80px' },
      { text: '가중치', value: 'weight', width: '80px' },
      { text: '메모', value: 'memo', width: '200px' },
      { text: '관리', value: 'actions', width: '80px', sortable: false },
    ],
    notiForm: {},
  }),
  created() {
    this.resetNotiForm();
    this.loadNotiServerList();
  },
  methods: {
    ...mapActions([
      'DANTA_GET_NOTI_SERVER_LIST',
      'DANTA_CREATE_NOTI_SERVER',
      'DANTA_UPDATE_NOTI_SERVER',
      'DANTA_DELETE_NOTI_SERVER',
    ]),
    async loadNotiServerList() {
      try {
        const body_data = await this.DANTA_GET_NOTI_SERVER_LIST();
        this.notiServerList = body_data.server_list || [];
      } catch (err) {
        console.error('노티 서버 리스트 로드 실패:', err);
      }
    },
    resetNotiForm() {
      this.notiForm = {
        server_id: '', server_name: '', host: '0.0.0.0', port: 4000,
        weight: 1, memo: '',
      };
    },
    openNotiDialog() {
      this.notiIsEdit = false;
      this.resetNotiForm();
      this.notiDialog = true;
    },
    openNotiEditDialog(item) {
      this.notiIsEdit = true;
      this.notiForm = JSON.parse(JSON.stringify(item));
      this.notiDialog = true;
    },
    async saveNotiServer() {
      const sid = (this.notiForm.server_id || '').trim();
      if (!sid) {
        alert('서버 ID 는 필수입니다. (ecosystem 의 BROADCAST_SERVER_ID 와 일치 — 예: broadcast-1)');
        return;
      }
      if (!this.notiForm.server_name) {
        alert('서버 이름은 필수입니다.');
        return;
      }
      const w = Number(this.notiForm.weight);
      if (!Number.isFinite(w) || w < 1) {
        alert('가중치는 1 이상의 정수여야 합니다.');
        return;
      }
      try {
        const data = JSON.parse(JSON.stringify(this.notiForm));
        data.server_id = sid;
        if (this.notiIsEdit) {
          await this.DANTA_UPDATE_NOTI_SERVER(data);
        } else {
          await this.DANTA_CREATE_NOTI_SERVER(data);
        }
        this.notiDialog = false;
        await this.loadNotiServerList();
      } catch (err) {
        console.error(err);
        alert(this.notiIsEdit ? '수정에 실패했습니다.' : '등록에 실패했습니다. (서버 ID 가 이미 존재할 수 있음)');
      }
    },
    async deleteNotiServer(item) {
      if (!confirm(`${item.server_name} 서버를 삭제하시겠습니까?`)) return;
      try {
        await this.DANTA_DELETE_NOTI_SERVER({ server_id: item.server_id });
        await this.loadNotiServerList();
      } catch (err) {
        console.error(err);
        alert('삭제에 실패했습니다.');
      }
    },
  },
};
</script>
